export default "__VITE_ASSET__BT4BX0y2__"